import React from 'react';

// Publicidad obligatoria de la subvención INNOVACTIVA 2025 (IAJ, Junta de Andalucía).
// Logo oficial facilitado por el IAJ (Junta + Consejería + IAJ), en public/subvencion/.
const LOGOS = [
  {
    src: '/subvencion/junta-andalucia-iaj.svg',
    alt: 'Junta de Andalucía. Consejería de Inclusión Social, Juventud, Familias e Igualdad. Instituto Andaluz de la Juventud',
  },
];

const FundingNotice = () => {
  return (
    <div className="mt-6 pt-6 border-t border-gray-800">
      <div className="bg-white rounded-lg px-6 py-5 flex flex-col md:flex-row items-center gap-6">
        <div className="flex items-center gap-6 flex-wrap justify-center shrink-0 max-w-full">
          {LOGOS.map((logo) => (
            <img
              key={logo.src}
              src={logo.src}
              alt={logo.alt}
              className="h-auto md:h-16 w-full md:w-auto max-w-md object-contain"
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          ))}
        </div>
        <p className="text-sm text-gray-800 text-center md:text-left">
          Proyecto subvencionado por la Junta de Andalucía, a través del Instituto Andaluz
          de la Juventud, en el marco de la línea de subvenciones INNOVACTIVA 2025 para la
          puesta en funcionamiento de proyectos empresariales por personas jóvenes andaluzas.
        </p>
      </div>
    </div>
  );
};

export default FundingNotice;
